import jQuery from 'jquery';
import focusWithin from 'focus-within';
import {nav} from './nav.js';
import {footer} from './footer.js';
import {tabs} from './tabs.js';
import {ticker} from './splide.js';
import {stats} from './stats.js';
import {accordions} from './accordions.js';
import {teams} from './teams.js';
import {hideSeek} from './hide-seek.js';
import {testimonialsSlider} from './testimonialsSlider.js';
import {filters} from './filters.js';
import {loadMore} from './load-more.js';
import {loadMoreEvents} from './load-more-events.js';
import {modal} from './modal.js';
import {blocks} from './blocks.js';
import {campaigns} from './campaigns.js';
import {twilio} from './twilio.js';
import {iframes} from './iframes.js';
import {banner} from './banner.js';
import sitewideCarousel from './sitewide-carousel.js';
import initGatedAccessForm from "./privateContent";
import {tabbedHideSeek} from "./tabbed-hide-seek";
import appCarousel from "./app-carousel";
import greenhouse from './greenhouse';
import {eventFilters} from "./events-filter";

import aiApp from './ai-app';
import dialogHelper from './dialog-helper.js';

jQuery(document).ready(function ($) {
    // Remove no-js class and replace with js.
    $('html').addClass('js').removeClass('no-js');

    // :focus-within polyfill
    focusWithin(document);

    window.getCookie = function (name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return match[2];
    }

    nav();
    footer();
    tabs();
    ticker();
    stats();
    accordions();
    teams();
    filters();
    loadMore();
    loadMoreEvents();
    eventFilters();
    modal();
    blocks();
    campaigns();
    //twilio();
    iframes();
    hideSeek();
    banner();
    initGatedAccessForm($);
    testimonialsSlider();
    sitewideCarousel();
    tabbedHideSeek();
    appCarousel();
    greenhouse($);
    dialogHelper();

    aiApp();
});